import { render } from "./purchasedetail.vue?vue&type=template&id=601f8ba6&scoped=true"
import script from "./purchasedetail.vue?vue&type=script&lang=js"
export * from "./purchasedetail.vue?vue&type=script&lang=js"

import "./purchasedetail.vue?vue&type=style&index=0&id=601f8ba6&scoped=true&lang=css"
import "./purchasedetail.vue?vue&type=style&index=1&id=601f8ba6&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601f8ba6"]])

export default __exports__